export default "__VITE_ASSET__YH5DRPL4__"